var React = require('react');

function IconInformation (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M682.146 603.497c-13.082 0-23.687-10.631-23.687-23.743s10.605-23.743 23.687-23.743 23.687 10.631 23.687 23.743-10.606 23.743-23.687 23.743zm-42.574 155.968V735.22h26.608v-94.545h-26.608V616.43l58.995-.317V735.22h26.608v24.245h-85.603zm42.813-260.874c-93.434 0-156.503 63.069-156.503 156.503s63.069 156.503 156.503 156.503c93.434 0 156.503-63.069 156.503-156.503s-63.069-156.503-156.503-156.503zm.713-45.815c112.147 0 203.031 90.885 203.031 203.031 0 112.1-90.885 203.031-203.031 203.031s-203.031-90.885-203.031-203.031 90.884-203.031 203.031-203.031zM252.586 217.697h594.809l.343 215.863h-53.98V270.896H306.66V758.79h161.554v53.204H252.586V217.697zM145.911 110.161h488.472v54.083H200.958v432.672H145.91V110.161z","clipRule":"evenodd"}));
}

IconInformation.displayName = "IconInformation";

IconInformation.defaultProps = {"viewBox":"15.167 -16.333 1000.636 1000.678"};

module.exports = IconInformation;

IconInformation.default = IconInformation;
